import React from 'react';
import {useReservation} from 'context/reservation';
import {getNumberOfGuests} from 'utils/reservation';
import {useTranslation} from 'react-i18next';
import {useComputedReservationDetails} from '../../../context/computedReservationDetails';
import {getTextDescriptionNumberOfGuests} from '../../../utils/common';
import StyledIcon from 'components/acommon/StyledIcon';
import {StyledDatesAndGuests, Col} from './styled';

type DatesAndGuestsBoxProps = {
  className?: string;
};
function DatesAndGuestsBox({className}: DatesAndGuestsBoxProps) {
  const {data: reservation} = useReservation();
  const {formattedCheckInDate, formattedCheckOutDate} = useComputedReservationDetails();
  const {t, i18n} = useTranslation();
  const numberOfGuests = getNumberOfGuests(reservation);

  const textDescriptionNumberOfGuests = getTextDescriptionNumberOfGuests(numberOfGuests, {
    language: i18n.language,
    t,
  });

  return (
    <StyledDatesAndGuests className={className}>
      <div className="halfOfDateAndGuests">
        <Col className="iconCol">
          <StyledIcon name="calendarIcon" size="24px" color="#777E90" />
        </Col>
        <Col>
          <div className="title">{t('dates')}</div>
          <div className="value">{formattedCheckInDate}</div>
          <div className="value">{formattedCheckOutDate}</div>
        </Col>
      </div>
      <div className="halfOfDateAndGuests">
        <Col className="iconCol">
          <StyledIcon name="smallGuestIcon" size="24px" color="#777E90" />
        </Col>
        <Col>
          <div className="title">{t('guests')}</div>
          <div className="value">{textDescriptionNumberOfGuests}</div>
        </Col>
      </div>
    </StyledDatesAndGuests>
  );
}

export default React.memo(DatesAndGuestsBox);
